import { isValid, parse, startOfToday } from 'date-fns'
import { t } from 'i18next'
import { ZodEffects, ZodObject, ZodRawShape, z } from 'zod'

export const EXPIRATION_TYPES = ['date', 'noExpiration'] as const
export type ExpirationType = (typeof EXPIRATION_TYPES)[number]

export type ApiKeyFormFields = {
  name: string
  roleNames: string[]
  expirationType: ExpirationType | ''
  expiresAt: string
}

export function parseExpiresAt(value: string): Date | undefined {
  if (value.trim() === '') {
    return undefined
  }
  const parsed = parse(value.trim(), 'yyyy/MM/dd', startOfToday())
  return isValid(parsed) ? parsed : undefined
}

// 期限日は「その日いっぱい有効」として扱う(送信時に endOfDay へ変換する)ため、当日も選べる。
// 期限切れのキーは期限を据え置いたままロール等を変更できないが、eauth 自体が
// 期限切れキーの更新を FAILED_PRECONDITION で拒否する(新しいキーの発行を促す)ため整合している。
export const apiKeyFormSchema = (): ZodEffects<ZodObject<ZodRawShape>> =>
  z
    .object({
      name: z.string().min(1, {
        message: t('message.required', {
          entity: t('pages.api_keys.label.name'),
        }),
      }),
      roleNames: z.array(z.string()),
      expirationType: z.enum(EXPIRATION_TYPES, {
        message: t('pages.api_keys.form.expiration.required'),
      }),
      expiresAt: z.string(),
    })
    .refine(
      ({ expirationType, expiresAt }) => {
        if (expirationType !== 'date') {
          return true
        }
        const parsed = parseExpiresAt(expiresAt)
        return parsed !== undefined && parsed >= startOfToday()
      },
      {
        message: t('pages.api_keys.form.expiresAt.invalid'),
        path: ['expiresAt'],
      },
    )
